<style scoped>
  .el-tab-sty {
      padding-left: 15px;
      border-radius: 6px 6px 0 0;
  } 
.bank-card { 
  border:1px solid #f1f1f1;
  height: 100px;
  border-radius: 6px;
}
.enclosure {
  height: 250px;
}
.enclosure .left {
  width: 57px;
  height: 82px;
  border: 1px solid #f1f1f1; 
  float: left;

}
  .enclosure .left  img{
        margin: 20px auto;
    }
 .enclosure .center{
  width: 120px;
  height: 82px;
  border: 1px solid #f1f1f1;
  margin-left: 55px;
  float: left; 
}
  .enclosure .center  img{
        margin: 8px auto;
    }
  .enclosure .right{
  width: 120px;
  height: 82px;
  border: 1px solid #f1f1f1;
  margin-left: 55px;
  float: left; 
} 
  .enclosure .right  img{
        margin: 8px auto;
    }

/deep/ .el-drawer.rtl{
    overflow: scroll;
}
.text-red {
  color: red;
}
</style>
<template>
  <div class="content">
  <!-- <div style="background-color: #f9f9f9;height: 50px;text-align: left;padding-left:15px;margin-bottom: 15px;">
     <p class="fl">审批时间：{{ApprovalTime}}        审批结果：</p>
     <p class="ml20 fl w25f" v-show="sh == 'true'">待审批</p>
     <p class="ml20 fl w25f" v-show="sh == '平台审批中'">平台审批中</p>
     <p class="ml20 fl w25f" v-show="sh == '平台审批通过' || sh == '平台审批通过'">平台审批通过</p>
     <p class="ml20 text-red fl w25f" v-show="sh == '平台已驳回'">平台已驳回</p>
  <el-button size="small" class="fr mr15 mt10" type="info" @click="addStaffApprovalHist">审批记录</el-button>  
  </div> -->
  <div class="search-area mb15">
    <div class="w100f t-left h100"> 
            <el-image style="width: 100px; height: 100px;border-radius: 8px; float: left;" v-if="getStaffBasicInfoList.registerPicture != null"
            :src="getStaffBasicInfoList.registerPicture.path" 
            :preview-src-list="srcList">
          </el-image>
          <!-- <img width="59" height="84" style="margin: 0;" :src="getStaffBasicInfoList.registerPicture.path" v-if="getStaffBasicInfoList.registerPicture != null"> -->
          <img width="100" height="100" class="fl" src="../../assets/images/personal.png" v-else> 
          <p style="line-height: 60px;width: 200px;margin-left: 30px;font-size: 20px;float: left;">{{getStaffBasicInfoList.staffName}}</p>
    </div> 
    </div>
  <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>基本信息</b></div>
      <el-row :gutter="24">   
         <el-col :span="5"><div class="search-area-div1">性别：{{getStaffBasicInfoList.sex == 'M'?"男":"女"}}  </div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">民族：{{getStaffBasicInfoList.nation}}</div> </el-col>
        <el-col :span="7"><div class="search-area-div1">手机号：{{getStaffBasicInfoList.mobileNo}}</div> </el-col>
      </el-row>
      <el-row :gutter="24"> 
        <el-col :span="5"><div class="search-area-div1">身份证：{{getStaffBasicInfoList.idCode}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div1">户口性质：{{getStaffBasicInfoList.familyRegisterType == 1?"农业户口":"非农业户口"}}</div> </el-col> 
        <el-col :span="10"><div class="search-area-div1 w100f t-left">户口所在地：{{getStaffBasicInfoList.familyRegisterVenue}}{{getStaffBasicInfoList.familyRegisterAddress}}</div> </el-col> 
      </el-row>  
    </div>
    <div class="search-area mb15" v-if="getStaffBasicInfoList.archiveTenants != null">
    <div class="w100f t-left mb15"><b>备案企业</b></div>    
      <div class="bank-card w25f">
                <div class="fl mt10 ml10 w35f t-left"><span>企业：{{getStaffBasicInfoList.archiveTenants[0].tenantName}}</span> <br><span>组织：{{getStaffBasicInfoList.archiveTenants[0].organisationName}}</span> <br><span>岗位：{{getStaffBasicInfoList.archiveTenants[0].positionNames}}</span></div>
      </div> 
    </div>
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>合同信息</b></div>
    <!-- <div class="t-left">基本工资：{{getStaffBasicInfoList.salary}}</div> -->
    <el-row :gutter="24">
        <el-col :span="7"><div class="search-area-div1">公司名称：{{getStaffBasicInfoList.levyCompanyName}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div1">签约状态：{{getStaffBasicInfoList.contractState}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">合同性质：{{getStaffBasicInfoList.contractNature == '1'?'劳动合同':'劳务合同'}}</div> </el-col> 
    </el-row>
    <el-row :gutter="24">
        <el-col :span="18"><div class="search-area-div1">合同期限：{{getStaffBasicInfoList.startTime | getDate}} ~ {{getStaffBasicInfoList.endTime | getDate}}</div> </el-col>   
    </el-row>
    </div>
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>社金信息</b></div>
    <!-- <div class="t-left">基本工资：{{getStaffBasicInfoList.salary}}</div> -->
    <el-row :gutter="24">
        <el-col :span="7"><div class="search-area-div1">代缴公司：{{getStaffBasicInfoList.withheldCompanyName}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div1">参保公司：{{getStaffBasicInfoList.insuredCompanyName}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">基本工资：{{getStaffBasicInfoList.salary}}</div> </el-col> 
    </el-row>
    <p class="t-left"><b>社保</b></p>
      <el-row :gutter="24">
        <el-col :span="7"><div class="search-area-div1">参保状态：{{getStaffBasicInfoList.insuranceState | insuranceStatus}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div1">参保地：{{getStaffBasicInfoList.insLocationName}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">开始缴纳时间：{{getStaffBasicInfoList.insPaymentTime}}</div> </el-col> 
      </el-row>
      <el-row :gutter="24"><!-- {{getStaffBasicInfoList.freeEmploymentAgreement=='Y'?'自由用工':'非自由用工'}} -->
      <el-col :span="7"><div class="search-area-div1">参保身份：{{getStaffBasicInfoList.expectInsLocationName}}</div> </el-col>
      <el-col :span="5"><div class="search-area-div1">参保基数：{{getStaffBasicInfoList.salary}}</div> </el-col> 
      </el-row> 
      <p class="t-left"><b>公积金</b></p>
      <el-row :gutter="24">
        <el-col :span="7"><div class="search-area-div1">参保状态：{{getStaffBasicInfoList.fundState | insuranceStatus}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div1">参保地：{{getStaffBasicInfoList.fundLocationName}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">开始缴纳时间：{{getStaffBasicInfoList.fundPaymentTime}}</div> </el-col> 
      </el-row>
      <el-row :gutter="24"><!-- {{getStaffBasicInfoList.freeEmploymentAgreement=='Y'?'自由用工':'非自由用工'}} -->
      <el-col :span="7"><div class="search-area-div1">缴纳比例：{{getStaffBasicInfoList.fund_ee_rate}}%</div> </el-col>
      <el-col :span="5"><div class="search-area-div1">参保基数：{{getStaffBasicInfoList.fundBase}}</div> </el-col> 
      </el-row> 
    </div>
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>工资账户</b></div>    
      <div class="bank-card w25f">
                <img class="img-sty-check fl ml10 mt10" width="42" height="42" src="../../assets/images/zgyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国银行'">
                <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zggsyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国工商银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgnyyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国农业银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgjsyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国建设银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgjsyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国建设银行股份有限公司总行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/jtyh.png" v-show="getStaffBasicInfoList.salaryBank =='交通银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgyzcx.png" v-show="getStaffBasicInfoList.salaryBank =='中国邮政储蓄'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zxyh.png" v-show="getStaffBasicInfoList.salaryBank =='中信银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zggdyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国光大银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgmsyh.png" v-show="getStaffBasicInfoList.salaryBank =='华夏银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国民生银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/gfyh.png" v-show="getStaffBasicInfoList.salaryBank =='广发银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zsyh.png" v-show="getStaffBasicInfoList.salaryBank =='招商银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/xyyh.png" v-show="getStaffBasicInfoList.salaryBank =='兴业银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/payh.png" v-show="getStaffBasicInfoList.salaryBank =='平安银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/pfyh.png" v-show="getStaffBasicInfoList.salaryBank =='浦发银行'">       
                <div class="fl mt10 ml10 w35f t-left"><span>{{getStaffBasicInfoList.salaryBank}}</span> <br><span>{{getStaffBasicInfoList.salaryBankCode}}</span> <br><span>{{getStaffBasicInfoList.salaryBankAccount}}</span></div>
      </div> 
    </div>
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>自由用工信息</b></div>  
      <el-row :gutter="24">
        <el-col :span="7"><div class="search-area-div1">是否参与自由用工：{{getStaffBasicInfoList.achievementBank != null ?"是":"否"}}</div> </el-col>   
        <el-col :span="7"><div class="search-area-div1">代征公司：{{getStaffBasicInfoList.levyCompanyName}}</div> </el-col>   
      </el-row> 
      <p class="t-left"><b>账户信息</b></p>
      <div class="bank-card w25f">
                <img class="img-sty-check fl ml10 mt10" width="42" height="42" src="../../assets/images/zgyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国银行'">
                <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zggsyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国工商银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgnyyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国农业银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgjsyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国建设银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgjsyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国建设银行股份有限公司总行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/jtyh.png" v-show="getStaffBasicInfoList.achievementBank =='交通银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgyzcx.png" v-show="getStaffBasicInfoList.achievementBank =='中国邮政储蓄'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zxyh.png" v-show="getStaffBasicInfoList.achievementBank =='中信银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zggdyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国光大银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgmsyh.png" v-show="getStaffBasicInfoList.achievementBank =='华夏银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国民生银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/gfyh.png" v-show="getStaffBasicInfoList.achievementBank =='广发银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zsyh.png" v-show="getStaffBasicInfoList.achievementBank =='招商银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/xyyh.png" v-show="getStaffBasicInfoList.achievementBank =='兴业银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/payh.png" v-show="getStaffBasicInfoList.achievementBank =='平安银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/pfyh.png" v-show="getStaffBasicInfoList.achievementBank =='浦发银行'">       
                <div class="fl mt10 ml10 w35f t-left"><span>{{getStaffBasicInfoList.achievementBank}}</span> <br><span>{{getStaffBasicInfoList.achievementBankCode}}</span> <br><span>{{getStaffBasicInfoList.achievementBankAccount}}</span></div>
      </div> 
    </div>
    <div class="search-area h120 mb15">
    <div class="w100f t-left mb15"><b>附件</b></div>
      <div class="enclosure">
          <div class="left">
            <el-image 
            style="width: 59px; height: 84px" v-if="getStaffBasicInfoList.registerPicture != null"
            :src="getStaffBasicInfoList.registerPicture.path" 
            :preview-src-list="srcList">
          </el-image>
          <!-- <img width="59" height="84" style="margin: 0;" :src="getStaffBasicInfoList.registerPicture.path" v-if="getStaffBasicInfoList.registerPicture != null"> -->
          <img width="40" src="../../assets/images/personal.png" v-else>
          </div> 
          <div class="center">
          <el-image 
            style="width: 122px; height: 84px"  :src="getStaffBasicInfoList.idFrontPictContent.path" v-if="getStaffBasicInfoList.idFrontPictContent != null"
            :preview-src-list="srcList">
          </el-image>
          <!-- <img width="122" height="84" style="margin: 0;" :src="getStaffBasicInfoList.idFrontPictContent.path" v-if="getStaffBasicInfoList.idFrontPictContent != null"> -->
          <img width="100" src="../../assets/images/id-z.png" v-else>
          </div>
          <div class="right">
          <el-image 
            style="width: 122px; height: 84px"  :src="getStaffBasicInfoList.idBackPictContent.path" v-if="getStaffBasicInfoList.idBackPictContent != null"
            :preview-src-list="srcList">
          </el-image>
          <!-- <img width="122" height="84" style="margin: 0;" :src="getStaffBasicInfoList.idBackPictContent.path" v-if="getStaffBasicInfoList.idBackPictContent != null"> -->
          <img width="100" src="../../assets/images/id-f.png" v-else>
          </div>
      </div>
    </div>  
    <div style="height: 800px;"></div> 
  </div>
</template>

<script> 
  export default {  
    data() {
      return {
        textTitle:'',
        drawer: false,
        reverse:false,
        activities: [{
          content: '支持使用图标',
          timestamp: '2018-04-12 20:46',
          size: 'large',
          type: 'primary',
          icon: 'el-icon-more'
        }],
        srcList:[],
        right:'',
        dialogVisible: false,
        dialogFormVisible:false,
        dialogFormVisible1:false,
        getStaffBasicInfoList:'' , 
        sh:'',
        insuredCompanys:[],
        contractNatures:[{
          value:'1',
          label:'劳动合同'
        },{
          value:'2',
          label:'劳务合同'
        }],
        withheldCompanys:[],
        levyCompanys:[],
        ruleForm: {
          staffInfo:'',
          insuredCompanyGuid:'',
          insuredCompanyName:'',
          contractNature: '',
          startTime: '',
          duration: '12',
          endTime: '',
          withheldCompanyGuid:'',
          withheldCompanyName:'',
          levyCompanyGuid:'',
          levyCompanyName:'',
          memo:''
        },
        approvalSuggest:'',
        getStaffApprovalHistList:'',
        ApprovalTime:'',
        bizState:'',
        itemsList:'',
        timeList:[], 
        timeListS:[],
      };
    },
    created(){ 
    // 列表
    this.getData(); 
    // this.getStaffApprovalHist();
    // this.getTenantDataGet();
    // this.getWithheldCompanys();
    // this.getLevyCompanys();
  }, 
    methods: {  
      getData() {
              let self = this; 
              self.srcList = [];
              self.api.get(`/${serverConfig.msPersonnelService}/staff/data/get-broker-detail?guid=`+this.$route.query.guid).then(res=>{ 
                console.log(res.data);
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){ 
                          self.getStaffBasicInfoList = res.data.data; 
                          // self.getStaffBasicInfoList.positionNames  = self.getStaffBasicInfoList.positionNames[0];
                          // self.getStaffBasicInfoList.inviterPositionNames  = self.getStaffBasicInfoList.inviterPositionNames[0];
                          self.getStaffBasicInfoList.idFrontPictContent = JSON.parse(res.data.data.idFrontPictContent); 
                          self.getStaffBasicInfoList.idBackPictContent = JSON.parse(res.data.data.idBackPictContent);
                          self.getStaffBasicInfoList.registerPicture = JSON.parse(res.data.data.registerPicture);
                          if(self.getStaffBasicInfoList.idFrontPictContent != null && self.getStaffBasicInfoList.idFrontPictContent != ''){
                                self.srcList.push(self.getStaffBasicInfoList.idFrontPictContent.path);
                          }
                          if(self.getStaffBasicInfoList.idBackPictContent != null && self.getStaffBasicInfoList.idBackPictContent != ''){
                                self.srcList.push(self.getStaffBasicInfoList.idBackPictContent.path);
                          }
                          if(self.getStaffBasicInfoList.registerPicture != null && self.getStaffBasicInfoList.registerPicture != ''){
                                self.srcList.push(self.getStaffBasicInfoList.registerPicture.path);
                          }

                          // self.srcList.push(self.getStaffBasicInfoList.idFrontPictContent.path,self.getStaffBasicInfoList.idBackPictContent.path,self.getStaffBasicInfoList.registerPicture.path);
                     }else {
                      self.$message.error(res.data.msg);
                     } 
              }) 
      }, 



    },
  };
</script> 